// eslint-disable-next-line
import axios from '../../tools/axios-instance.js'

export default {
  namespaced: true,
  state: {
    isConfigMode: false,
    stepFilled: 0,
    mainconfig: {
      currency: '&euro;', // #TODO à rendre dynamique ?
      weight: 'kg', // #TODO à rendre dynamique ?
      bgColor: '#85C33F',
      logo: '',
      background: '',
      font: 'Avenir, Helvetica, Arial, sans-serif' // #TODO à rendre dynamique ?
    },
    knowus: [],
    target: [],
    cgv: '',
    commitments: [],
    options: [],
    offers: [],
    prices: {
      insurance: {
        active: false,
        name: '',
        price: ''
      },
      smoothIncrease: {
        active: false,
        name: '',
        price: '',
        duration: '',
        commitment: 'month'
      },
      employedPackages: {
        active: false,
        name: '',
        price: '',
        duration: '',
        commitment: 'month'

      }
    },
    activeSurprise: false,
    starterPack: '',
    defaultCommitment: ''
  },

  getters: {
    isConfigOk: state => {
      return state.knowus.length !== 0 && state.target.length !== 0 && state.options.length !== 0 && state.offers.length !== 0;
    },
    jsonConfig: state => {
      return JSON.stringify(state);
    }
  },

  mutations: {
    CONFIG_LOAD: (state, json) => {
      var jsonParsed = JSON.parse(json);
      for (var property in jsonParsed) {
        state[property] = jsonParsed[property];
      }
    },
    CONFIG_SETCOLOR: (state, color) => {
      if (color !== undefined) {
        state.mainconfig.bgColor = color;
      }
    },
    CONFIG_SETPRICES: (state, {field, subfield, value}) => {
      if (field !== undefined && value !== undefined) {
        state.prices[field][subfield] = value;
      }
    },
    CONFIG_SAVEDATA: (state, data) => {
      if (data !== undefined) {
        Object.keys(data).forEach((key) => {
          state[key] = data[key];
        });
      }
    },
    CONFIG_SETOFFER: (state, {index, field, subfield, value}) => {
      if (value !== undefined) {
        if (field !== null) {
          state.offers[index][field][subfield] = value;
        } else {
          state.offers[index][subfield] = value;
        }
      }
    },
    CONFIG_TOGGLECONFIGMODE: (state) => {
      state.isConfigMode = !state.isConfigMode;
    },
    CONFIG_SETLOGO: (state, url) => {
      state.mainconfig.logo = (url !== '') ? url + '?i=' + Math.random() : '';
    },
    CONFIG_SETBACKGROUND: (state, url) => {
      state.mainconfig.background = (url !== '') ? url + '?i=' + Math.random() : '';
    },
    CONFIG_SAVESTEPFILLED: (state, index) => {
      state.stepFilled = index;
    }
  },

  actions: {
    CONFIG_LOAD: (context, json) => {
      context.commit('CONFIG_LOAD', json);
    },
    CONFIG_SETLOGO: (context, url) => {
      context.commit('CONFIG_SETLOGO', url);
    },
    CONFIG_SETBACKGROUND: (context, url) => {
      context.commit('CONFIG_SETBACKGROUND', url);
    },
    CONFIG_SETCOLOR: (context, color) => {
      context.commit('CONFIG_SETCOLOR', color);
    },
    CONFIG_SETCGV: (context, cgv) => {
      context.commit('CONFIG_SETCGV', cgv);
    },
    CONFIG_SETKNOWUSLIST: (context, knownUsList) => {
      context.commit('CONFIG_SETKNOWUSLIST', knownUsList);
    },
    CONFIG_SETPRICES: (context, {field, subfield, value}) => {
      context.commit('CONFIG_SETPRICES', {field, subfield, value});
    },
    CONFIG_SETOFFER: (context, {index, field, subfield, value}) => {
      context.commit('CONFIG_SETOFFER', {index, field, subfield, value});
    },
    CONFIG_SAVEDATA: (context, data) => {
      context.commit('CONFIG_SAVEDATA', data);
    },
    CONFIG_TOGGLECONFIGMODE: (context) => {
      context.commit('CONFIG_TOGGLECONFIGMODE');
    },
    CONFIG_SAVESTEPFILLED: (context, index) => {
      context.commit('CONFIG_SAVESTEPFILLED', index);
    },
    CONFIG_UPLOADCONFIG: (context, token) => {
      return axios.post('config',
        {
          'code': 'config_vente',
          'val': context.getters.jsonConfig
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/config.js